import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import Text from '../../../components/Text'
import routes from '../../../config/routes'


interface Props {

}

const ActivateLandingScreen: React.FC<Props> = () => {
  const { token, user, setUser } = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isRedirectActivate, setIsRedirectActivate] = useState<boolean>(false)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [message, setMessage] = useState<string>()
  const history = useHistory()

  const path = window.location.pathname
  const splited = path.split('/', 5)
  const user_id = splited[3]
  const activateUrl = process.env.REACT_APP_API_URL + path + window.location.search

  function setIndex() {
    history.push(routes.index.path)
  }

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: activateUrl,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => {
      if (mounted) {
        setIsLoading(false)
        setMessage(data.message)
        setTimeout(setIndex,10000)
        setIsActive(true)
        //setUser?.(data.data)
        setUser?.(user.verified = true)
      }
    }).catch(() => {
      if (mounted) {
        setIsLoading(false)
        setIsRedirectActivate(true)
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div>
      <Text
        tag="h1"
      >
        Ativando sua conta
      </Text>
      <Text
        tag="p"
      >
        Espere, por favor
      </Text>
      <Text
        tag="p"
      >
        {message}
      </Text>
      <Text
        tag="p"
      >
        {(isActive && 'Você será redirecionado para a página inicial em 10s ...' )}
      </Text>
      <Text
        tag="p"
      >
        {(isRedirectActivate &&
          <Button
            label="Reenviar e-mail"
            onClick={(evt: any) => {
              Axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_URL}/email/resend/${user_id}`,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }).then(({ data }) => {
                toast.success(data.message)
              }).catch(() => {
                toast.error('Ocorreu um erro, verifique sua conexão com a Internet')
              })
            }}
          >
          </Button>
        )}
      </Text>
      {(isLoading &&
        <Loader
          darkMode
        />
      )}
    </div>
  )
}

export default ActivateLandingScreen
